<script lang="ts">
  import type UserSignup from '../domain/user-signup';
  import ApiService from '../api-service';
  import { snackbar } from '../stores';
  import { push } from 'svelte-spa-router';
  import { Card, Button, TextField } from 'smelte';
  import ValidationUtils from "../utils/validation-utils";
  import { form } from 'svelte-forms';


  export let userSignup: UserSignup = {
    username: null,
    password: null,
    passwordRepeat: null
  };

  const signupForm = form(() => ({
    username: { value: userSignup.username, validators: ['required'] },
    password: { value: userSignup.password, validators: ['required'] },
    passwordRepeat: { value: userSignup.passwordRepeat, validators: ['required'] }
  }));

  $: formErrors = {
    'username': ValidationUtils.createErrors($signupForm, 'username'),
    'password': ValidationUtils.createErrors($signupForm, 'password'),
    'passwordRepeat': ValidationUtils.createErrors($signupForm, 'passwordRepeat')
  };

  async function signup() {
    await ApiService.signup(userSignup);
    snackbar.show('Kasutaja registreeritud');
    push('/login');
  }
</script>

<section class="flex justify-center items-center h-screen">
  <Card.Card hover={false} class="w-full md:w-1/3 shadow-lg px-3 py-3">
    <div slot="title" class="p-0 m-0">
      <div class="text-lg pl-4 py-2">Registreeri kasutaja</div>
    </div>
    <div slot="text">
      <TextField bind:value={userSignup.username} label="Kasutajanimi" error={ValidationUtils.createErrors($signupForm, 'username')}/>
      <TextField type="password" bind:value={userSignup.password} label="Parool"  error={ValidationUtils.createErrors($signupForm, 'password')}/>
      <TextField type="password" bind:value={userSignup.passwordRepeat} label="Parool veelkord"  error={ValidationUtils.createErrors($signupForm, 'passwordRepeat')}/>
    </div>
    <div slot="actions" class="flex justify-end">
      <Button on:click={signup} disabled="{!$signupForm.valid}">Registreeri</Button>
    </div>
  </Card.Card>
</section>
